import React from "react";
import "./Testimonial.css";
import {
  ApartmentOutlined,
  EyeOutlined,
  IdcardOutlined,
} from "@ant-design/icons";
import { message } from "antd";

import PDF from "../Data/my-cv.pdf";
import ZIP from "../Data/Business Card.zip";

export default function Testimonial() {
  const [messageApi, contextHolder] = message.useMessage();
  const success2 = () => {
    messageApi
      .loading({
        content: "Get Ready...!!",
        duration: 1.5,
      })
      .then(() => {
        window.open(PDF, "_blank");
        message.success("Get Ready", 2.5);
      });
  };

  const handleDownload = () => {
    messageApi
      .loading({
        content: "Download...!!",
        duration: 1.5,
      })
      .then(() => {
        const link = document.createElement("a");
        link.href = ZIP;
        link.download = "Business Card.zip";
        link.click();
      });
  };
  return (
    <div className="Testimonial-Body">
      {contextHolder}
      <div className="Testimonial-Box">
        <div className="Testimonial-Left">
          <TestimonialContent
            text="Lorem Ipsum simpy dummy text of the printing and types industry has been the industr standard dummy."
            name="Raleigh Friend"
            post="CEO, Seoly"
            rating={4}
          />
          <div className="Testimonial-Zip-Div">
            <button className="Testimonial-Left-Button" onClick={success2}>
              View CV
              <EyeOutlined />
            </button>

            <button
              className="Testimonial-Left-Button"
              onClick={handleDownload}
            >
              Business Card
              <IdcardOutlined />
            </button>
          </div>
        </div>
        <div className="Testimonial-Right">
          <p className="Testimonial-Text1">|| Testimonial</p>
          <p className="Testimonial-Text2">Satisfied Clients Say</p>
          <TestimonialContent
            text="Lorem Ipsum simpy dummy text of the printing and types industry has been the industr standard dummy."
            name="Raleigh Friend"
            post="CEO, Seoly"
            rating={4}
          />
        </div>
        <div className="Testimonial-Left1">
          <TestimonialContent
            text="Lorem Ipsum simpy dummy text of the printing and types industry has been the industr standard dummy."
            name="Raleigh Friend"
            post="CEO, Seoly"
            rating={4}
          />
          <div className="Testimonial-Zip-Div">
            <button className="Testimonial-Left-Button" onClick={success2}>
              View Resume
              <EyeOutlined />
            </button>

            <button
              className="Testimonial-Left-Button"
              onClick={handleDownload}
            >
              Business Card
              <IdcardOutlined />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function TestimonialContent({ text, name, post, rating }) {
  const renderRatingStars = () => {
    const stars = [];
    for (let i = 0; i < 5; i++) {
      if (i < rating) {
        stars.push(
          <span key={i} className="TestimonialContent-Star">
            &#9733;
          </span>
        );
      } else {
        stars.push(
          <span key={i} className="TestimonialContent-Star">
            &#9734;
          </span>
        );
      }
    }
    return stars;
  };

  return (
    <div className="TestimonialContent-Body">
      <div className="TestimonialContent-Box">
        <ApartmentOutlined className="TestimonialContent-Icon" />
        <p className="TestimonialContent-Text1">{text}</p>
        <p className="TestimonialContent-Text2">{name},</p>
        <div className="TestimonialContent-Div">
          <p className="TestimonialContent-Text3">{post}</p>
          <div className="TestimonialContent-Rating">{renderRatingStars()}</div>
        </div>
      </div>
    </div>
  );
}
